/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  FormControlLabel, Box, Select, MenuItem,
} from '@material-ui/core';
import { LOGOUTPUT_ACTIONS } from '../../../common/const';
import {
  setTargetYM, setTargetFunc, setDispAccessLog, getAccessLog,
  setTargetList, setRoleList,
} from '../../actions/LogOutputAction';
import { setSystemLodingFLg } from '../../actions/CommonAction';
import styles from './LogOutputSearchComponent.module.css';
import CustomRadio from '../common/CustomRadio';

/**
 * アクセスログ画面コンポーネント
 */
class LogOutputSearchComponent extends Component {
  componentDidMount() {
    const {
      setTargetYMAct,
      targetYM,
      setTargetListAct,
      setTargetFuncAct,
      targetFunc,
      setRoleListAct,
    } = this.props;

    // 対象年月
    const date = new Date();
    date.setDate(1);
    let yyyy = date.getFullYear();
    let mm = ('0'.concat(date.getMonth() + 1)).slice(-2);
    let yyyymm = yyyy + '/'.concat(mm);
    if (!targetYM) {
      setTargetYMAct(yyyymm);
    }

    // 対象年月リスト
    const tList = [];
    for (let i = 0; i <= 12; i += 1) {
      yyyy = date.getFullYear();
      mm = ('0'.concat(date.getMonth() + 1)).slice(-2);
      yyyymm = yyyy + '/'.concat(mm);
      tList.push(yyyymm);
      date.setMonth(date.getMonth() - 1);
    }

    setTargetListAct(tList);

    // 機能リスト
    const rList = [];
    Object.keys(LOGOUTPUT_ACTIONS).forEach((v) => {
      rList.push(LOGOUTPUT_ACTIONS[v]);
    });
    if (!targetFunc) {
      setTargetFuncAct(LOGOUTPUT_ACTIONS.ALL);
    }

    setRoleListAct(rList);
  }

  /**
   * セレクトボックスから選択中のデータを取得
   * @param {*} target select box element
   * @returns selected item
   */
  getSelectedList = (target) => {
    let selectedItem = [];
    selectedItem = target.value;
    return selectedItem;
  }

  /**
   * 引数でフィルタリングしたアクセスログデータを取得
   * @param {*} action selected radio button
   * @returns filltered Data
   */
  getFilteringLog = (action) => {
    const { accessLog } = this.props;
    const base = accessLog;
    const newList = [];

    base.map((v) => {
      if (action === LOGOUTPUT_ACTIONS.ALL) {
        newList.push(v);
      } else {
        const item = {
          date: v.date,
          [action]: v[action],
        };
        newList.push(item);
      }
      return null;
    });
    return newList;
  }

  /**
   * 対象年月選択時イベント
   * @param {*} ev React.changeEvent
   */
  selectTargetDate = async (ev) => {
    const { setTargetYMAct, getAccessLogAct, setSystemLodingFLgAct } = this.props;
    const { target } = ev;
    const selectValue = this.getSelectedList(target);
    setTargetYMAct(selectValue);

    // 対象月のアクセスログ取得
    setSystemLodingFLgAct(true);
    await getAccessLogAct();
    setSystemLodingFLgAct(false);
  }

  /**
   * 機能選択時イベント
   * @param {*} v selected radio button
   */
  selectAction = async (v) => {
    const { setTargetFuncAct, setDispAccessLogAct } = this.props;
    setTargetFuncAct(v);

    // 表示のフィルタリング
    const data = this.getFilteringLog(v);
    await setDispAccessLogAct(data);
  }

  render() {
    const {
      targetYM,
      targetFunc,
      targetList,
      roleList,
    } = this.props;

    return (
      <div className={`${styles.settings}`}>
        <ul className={`${styles.searchcontent}`}>
          <li className={`${styles.selectrow}`}>
            <Box className={`${styles.title}`}>対象年月</Box>
            <div className={`${styles.selectflex}`}>
              <Select
                variant="outlined"
                className={`${styles.selectfsizing}`}
                value={targetYM || ''}
                onChange={(ev) => { this.selectTargetDate(ev); }}
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: { vertical: 35, horizontal: 0 },
                  PaperProps: {
                    className: styles.custompaper,
                  },
                }}
              >
                {targetList && targetList.map((targetDate, i) => (
                  <MenuItem
                    key={i}
                    value={targetDate}
                  >
                    {targetDate}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </li>
          <li className={`${styles.radiorow}`}>
            <Box className={`${styles.title}`}>機能</Box>
            <div className={`${styles.radioRow}`}>
              {roleList && roleList.map((action) => (
                <div className={`${styles.radioItem}`} key={action}>
                  <FormControlLabel
                    control={<CustomRadio />}
                    label={action}
                    className={targetFunc === action
                      ? styles.radioButtonCheck : styles.radioButton}
                    checked={targetFunc === action}
                    onClick={() => this.selectAction(action)}
                  />
                </div>
              ))}
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    targetYM: state.logoutput.targetYM,
    targetFunc: state.logoutput.targetFunc,
    accessLog: state.logoutput.accessLog,
    targetList: state.logoutput.targetList,
    roleList: state.logoutput.roleList,
  }),
  (dispatch) => ({
    setTargetYMAct: (str) => dispatch(setTargetYM(str)),
    setTargetFuncAct: (str) => dispatch(setTargetFunc(str)),
    setDispAccessLogAct: (obj) => dispatch(setDispAccessLog(obj)),
    getAccessLogAct: (str1, str2) => dispatch(getAccessLog(str1, str2)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setTargetListAct: (obj) => dispatch(setTargetList(obj)),
    setRoleListAct: (obj) => dispatch(setRoleList(obj)),
  }),
)(LogOutputSearchComponent);
